<template>
  <v-app>
    <v-app-bar
      app
      color="info"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Your HR System Logo"
          class="shrink mr-2"
          contain
          src="@/assets/yhrs_logo.png"
          transition="scale-transition"
          width="200"
        />

        <!-- Your HR Audit -->

        <!-- <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        /> -->
      </div>

      <v-spacer></v-spacer>

      <!-- <v-btn
        @click=""
        text
      >
        <span class="mr-2">Start New</span>
        <v-icon>add</v-icon>
      </v-btn> -->
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
    <!-- <v-footer color="" app height="55">
			<v-spacer></v-spacer>
			<v-btn>
				Save Changes
			</v-btn>
		</v-footer> -->
  </v-app>
</template>

<script>


export default {
  name: 'App',
  data: () => ({
    //
  }),
};
</script>
